import { ResearchProjectResult } from 'interface/research'
import { useState, useCallback } from 'react'

export const useResearchPreviewDialog = () => {
	const [projectList, setProjectList] = useState<ResearchProjectResult[]>([])
	const [projectKey, setProjectKey] = useState<string | null>(null)

	const openProject = useCallback(
		(projectKey: string | null) => {
			setProjectKey(projectKey)
		},
		[setProjectKey]
	)
	const close = useCallback(
		() => openProject(null),
		[openProject]
	)
	return {
		projectList,
		projectKey,
		setProjectList,
		openProject,
		close
	}
}